import { render, staticRenderFns } from "./formDesign.vue?vue&type=template&id=a4c71c34&scoped=true&"
import script from "./formDesign.vue?vue&type=script&lang=ts&"
export * from "./formDesign.vue?vue&type=script&lang=ts&"
import style0 from "./formDesign.vue?vue&type=style&index=0&id=a4c71c34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c71c34",
  null
  
)

export default component.exports